import { Language } from '../../types';

const languages: [Language, Language] = [Language.En, Language.He];

export default languages;